import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReviewReasonComponent } from 'src/app/admin/components/review-reason/review-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-admin-social-impact',
  templateUrl: './admin-social-impact.component.html',
  styleUrls: ['./admin-social-impact.component.css'],
})
export class AdminSocialImpactComponent implements OnInit {
  updateForm: FormGroup;
  private getApi = environment.url + environment.socialGet;
  private updateStatusApi = environment.url + environment.updateStatus;
  /**
   * Constructor for the AdminSocialImpactComponent.
   * @param changeDetectorRef Reference to Angular's change detector for triggering change detection.
   * @param media Service to match media queries for responsive design.
   * @param getdata Service to retrieve values or data needed by the component.
   * @param fb FormBuilder service for creating reactive forms.
   * @param makeapi Service for making API calls.
   * @param dialog Material dialog service for opening dialogs.
   * @param notify Service for displaying notifications.
   * @param appCom Reference to the root AppComponent.
   * @param http Angular HttpClient for HTTP requests.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private getdata: ValueService,
    private fb: FormBuilder,
    private makeapi: ApiService,
    public dialog: MatDialog,
    private notify: NotifyService,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    /**
     * Initialize the update form with an incubator ID field.
     */
    this.updateForm = this.fb.group({
      incubatorId: [''],
    });
    /**
     * Initialize the mobile query listener to detect changes in the mobile query.
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  incubaterName;
  /**
   * Initializes the component after Angular has finished initializing it.
   * Retrieves the incubator name from session storage, updates the update form with the incubator ID from session storage,
   * fetches the data from the API, and retrieves the guideline data.
   */
  ngOnInit(): void {
    // Retrieve the incubator name from session storage and assign it to the component property
    this.incubaterName = sessionStorage.getItem('adminIncubName');

    // Get the current form values and update the incubator ID from session storage
    let getform = this.updateForm.value;
    getform.incubatorId = sessionStorage.getItem('incubator');

    // Update the form with the modified values
    this.updateForm.patchValue(getform);

    // Fetch the data from the API
    this.getDataApi();

    // Retrieve the guideline data
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches the data from the API using the incubator ID from session storage and updates the component's data on success.
   */
  getDataApi() {
    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Make the API request
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        // Hide the loading indicator and update the component's data
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
      });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Downloads a file from the provided URL using the FileSaver library.
   * @param value - The URL of the file to download.
   */
  download(value) {
    // Define the URL of the PDF to be downloaded
    const pdfUrl = value;

    // Define the name for the downloaded PDF file
    const pdfName = 'your_pdf_file';

    // Use the FileSaver library to initiate the download
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  /**
   * Approves an item by adding a control to the form, submitting the update, and handling the response.
   * @param keys - The key to add as a control in the form.
   * @param id - The value to set for the added control.
   */
  approveBtn(keys, id) {
    // Add the key as a control in the form, and set its value to the provided id
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);

    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Get the current form values
    let getform = this.updateForm.value;

    // Submit the form with the updated values
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        // Hide the loading indicator once the request is complete
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // If the request was successful, notify the user of success
          this.notify.notifysuccess(data.responseMessage);
          // Remove the control from the form
          this.updateForm.removeControl(keys);
          // Refresh the data
          this.getDataApi();
        } else {
          // If the request was not successful, notify the user of an error
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Rejects an item by adding a control to the form, submitting the update, and handling the response.
   * @param keys - The key to add as a control in the form.
   * @param id - The value to set for the added control.
   */
  rejectBtn(keys, id) {
    // Add the key as a control in the form, and set its value to the provided id
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);

    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Get the current form values
    let getform = this.updateForm.value;

    // Submit the form with the updated values
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        // Hide the loading indicator once the request is complete
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // If the request was successful, notify the user of success
          this.notify.notifysuccess(data.responseMessage);
          // Remove the control from the form
          this.updateForm.removeControl(keys);
          // Refresh the data
          this.getDataApi();
        } else {
          // If the request was not successful, notify the user of an error
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Opens the ReviewReasonComponent dialog to review an item with the given key and status.
   * Refreshes the data after the dialog is closed.
   * @param key - The unique identifier for the item to review.
   * @param status - The current status of the item.
   */
  reviewBtn(key, status) {
    const dialogRef = this.dialog.open(ReviewReasonComponent, {
      width: '390px',
      data: { _key: key, _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the data after the dialog is closed
      this.getDataApi();
    });
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[6].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }
  prevStep() {
    this.step--;
  }
}
